"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Analytics Events
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnumInvitationStatus = void 0;
/**
 * This is the status of a friends and family invitation.
 */
exports.EnumInvitationStatus = {
    Pending: 'Pending',
    Expired: 'Expired',
    Claimed: 'Claimed',
    Unclaimed: 'Unclaimed',
};
//# sourceMappingURL=enum-invitation-status.js.map